import { FC, PropsWithChildren } from 'react';
import { logger } from '@belong/logging/logger';
import { IWithLink } from '@belong/types';
import { config, defaultRenderer } from './renderers';

export const withLink = <P extends object>(LinkComponent: FC<P>): FC<PropsWithChildren<P & IWithLink>> => {
  const withLinkFactory: FC<any> = (props: P & IWithLink) => {
    const { debug, linkRenderers, routes, defaultLinkRenderer } = withLink.config;
    const renderer = Object.values(linkRenderers).find(item => item.test(props, routes));
    const linkProps = {
      ...props,
      children: props.children ?? props.label
    };

    if (renderer) {
      if (debug) {
        logger.debug(`${renderer.name} renderer - href: ${linkProps.href}, asUrl: ${linkProps.asUrl}`);
      }

      return renderer.render(LinkComponent, linkProps, withLink.config);
    }

    logger.debug(`!! Using default renderer !! (${linkProps.href}, asUrl: ${linkProps.asUrl})`);
    return (defaultLinkRenderer ?? defaultRenderer).render(LinkComponent, linkProps, withLink.config);
  };

  withLinkFactory.displayName = 'withLink';
  return withLinkFactory;
};

// Attach overridable config
withLink.config = config;
export default withLink;
